import { WrapItem } from '@chakra-ui/react'
import type { RefObject } from 'react'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type {
  CustomMetadataResponse, FormValidationObject, RemoveFilterProps, SearchQueryJson
} from '../../../interfaces'
import FilterNew from './Filter'


interface Props {
  page: 'media-library' | 'media-collection'
  searchQueryJson: SearchQueryJson
  customMetadataFields: CustomMetadataResponse[]
  customMetadataFieldsMapping: { [fieldName: string]: CustomMetadataResponse }
  validationObject: FormValidationObject
  groupId: number
  maxWidthRef: RefObject<any>
  wrapRef: RefObject<HTMLDivElement>
  shouldAutoOpenFilterId?: number
  setSearchQueryJson(SearchQueryJson: SearchQueryJson): void
  removeFilter(removeFilterProps: RemoveFilterProps): void
}

const FilterGroup = (props: Props): React.ReactElement => {
  const {
    searchQueryJson,
    setSearchQueryJson,
    customMetadataFields,
    customMetadataFieldsMapping,
    validationObject,
    groupId,
    maxWidthRef,
    wrapRef,
    removeFilter,
    page,
    shouldAutoOpenFilterId,
  } = props

  const filterGroupJson = useMemo(
    () => searchQueryJson.filterGroups[groupId],
    [searchQueryJson, groupId],
  )

  return (
    <>
      {filterGroupJson.expressions.map((expression, index) => (
        <>
          <WrapItem>
            <FilterNew
              key={index}
              {...{
                searchQueryJson,
                setSearchQueryJson,
                customMetadataField:
                  customMetadataFieldsMapping[expression.fieldName],
                customMetadataFields,
                customMetadataFieldsMapping,
                validationObject,
                groupId,
                filterId: index,
                maxWidthRef,
                wrapRef,
                removeFilter,
                shouldAutoOpen: shouldAutoOpenFilterId === index,
              }}
            />
          </WrapItem>
        </>
      ))}
    </>
  )
}

export default FilterGroup
